import _ from 'lodash'
import { UnknownRecord } from 'type-fest'

export const hasAnyNestedObject = <T extends Record<string, unknown>>(obj: T): boolean =>
  Object.keys(obj).some((key: keyof T) => typeof obj[key] === 'object' && obj[key] !== null)

export const collectNestedObjectsKeys = <T extends Record<string, unknown>>(obj: T): (keyof T)[] =>
  Object.keys(obj).filter((key: keyof T): boolean => _.isObject(obj[key]))

export const deepRemoveNestedEmptyObjects = <T extends UnknownRecord>(obj: T): T =>
  _(obj)
    .mapValues((value: unknown): unknown =>
      _.isPlainObject(value) ? deepRemoveNestedEmptyObjects(value as T) : value,
    )
    .omitBy((value: unknown): boolean => _.isPlainObject(value) && _.isEmpty(value))
    .value() as T
